export default __webpack_public_path__ + "static/media/1634.e7d55875.png";